export const selectElevationHazards = (state: any) => state.elevationHazards.geoJson;

